import { startOfYear, subYears } from "date-fns";
import { FinancialAccount } from "@common/types/financialAccount";
import { useLockDate } from "@api/lock.api";
import { useConstant } from "@hooks/useConstant";
import { useTransactionsQuery } from "@components/transactions/useTransactionsQuery";

export function useLockedTransactionsForFinancialAccount(
    account: FinancialAccount,
) {
    const lockDate = useLockDate(account.entityId);
    const farPastEnd = useConstant(() => subYears(startOfYear(new Date()), 10));
    const {
        query: {
            data: lockedTransactionsData,
            isLoading: lockedTransactionsLoading,
        },
    } = useTransactionsQuery({
        filters: {
            accountIds: [account.id],
            entityIds: [account.entityId!],
            end: lockDate ?? farPastEnd, // because we could not use hook conditionally - set end date in the far past in case if there is no lock date
        },
        page: 1,
        limit: 1, // we need only total that's why we set the lowest safe value
    });
    const lockedTransactionsCount = lockedTransactionsData?.total ?? 0;

    return {
        lockedTransactionsCount,
        lockedTransactionsLoading,
        hasLockedTransactions: lockedTransactionsCount > 0,
    };
}
